import React, { Component } from "react";
import Modal from 'react-modal';
import ButtonWithIcon from "./ButtonWithIcon";
import waiting from '../res/waiting.png';
import * as API from '../api.js';
import verifiedIcon from '../assets/tick-mark.png';
import { getActiveTeam } from "../Teams";

Modal.setAppElement('#root');

export default class UpdateSecondaryInfo extends Component {
    state = {
        subscriptions: [],
        user: {},
        type: "",
        createIcon: waiting,
        org: {},
        models: [],
        model: {},
        billingDetails: {
            full_name: "-",
            company_name: "-",
            billing_address: "-",
            gst_number: "-",
            mob_number: "-",
            billing_email: "-",
            pin_code: "-",
            country: "-",
            state: "-"
        },
        personalDetailsWarning: { invalidPhone: false, invalidEmail: false, samePhone: false },
        changeMobileNumberPopup: false,
        countryLoader: true,
        stateLoader: true,
        countries: [],
        states: [],
        billingStates: [],
        billingStateLoader: false,
        isBillingPhoneInvalid: false,
        isBillingPhoneSameAsUser: false,
        isBillingEmailInvalid: false,
        isBillingNameInvalid: false,
    }

    isUpdateDisabled = () => {
        const {
            user,
            billingDetails,
            personalDetailsWarning,
            isBillingPhoneInvalid,
            isBillingPhoneSameAsUser,
            isBillingEmailInvalid,
            isBillingNameInvalid
        } = this.state;

        const requiredUserFields = [
            user.first_name,
            user.last_name,
            user.phone,
            user.address,
            user.country,
            user.state
        ];

        const requiredBillingFields = [
            billingDetails.full_name,
            billingDetails.company_name,
            billingDetails.billing_address,
            billingDetails.gst_number,
            billingDetails.mob_number,
            billingDetails.billing_email,
            billingDetails.pin_code,
            billingDetails.country,
            billingDetails.state
        ];

        const hasEmptyUserField = requiredUserFields.some(f => !f || f === '-');
        const hasEmptyBillingField = requiredBillingFields.some(f => !f || f === '-');

        return (
            hasEmptyUserField ||
            hasEmptyBillingField ||
            personalDetailsWarning.invalidEmail ||
            personalDetailsWarning.invalidPhone ||
            personalDetailsWarning.samePhone ||
            isBillingPhoneInvalid ||
            isBillingPhoneSameAsUser ||
            isBillingEmailInvalid ||
            isBillingNameInvalid
        );
    }


    getAllSubscriptions = () => {
        API.getAllSubscriptions().then((data) => {
            this.setState((state) => ({
                ...state,
                subscriptions: data.subscriptions
            }))
        }, (e) => { console.log(e); })
    }

    isNoAnyChangesMade = () => {
        return (
            this.state.user.address === this.props.user.address
            && this.state.user.first_name === this.props.user.first_name
            && this.state.user.last_name === this.props.user.last_name
            && this.state.user.state === this.props.user.state
            && this.state.user.country === this.props.user.country
            && this.state.user.phone === this.props.user.phone
            && this.state.avatarUrlData == this.state.avatarUrlData1
        )
    }

    submitEditUser = (e, mobileVerified, updateAvtar) => {
        if (e) e.preventDefault()
        const submitUser = (user) => {
            API.Useredit(user).then(() => {
                API.getUserType().then(([blah, type, user]) => {
                    if (!user.sub) {
                        user.sub = {
                            "plan": "aeromegh_plan_free"
                        }
                    }
                    this.setState((state) => ({
                        ...state,
                        user,
                        user: user,
                        type,
                    }), () => {
                        this.props.save()
                    })
                })
            })
        }

        if (updateAvtar) {
            submitUser(this.state.user)
        } else if (this.state.user.phone !== this.props.user.phone && !mobileVerified) {
            this.setState({ changeMobileNumberPopup: true })
        } else {
            this.setState((state) => ({ ...state, loading: true, }))
            let user = this.state.user
            user.country = user.country == '-' ? '-' : user.country
            user.state = user.state == '-' ? '-' : user.state
            user.phone = mobileVerified || this.state.user.phone
            submitUser(user)
        }
    }

    toggleSubCancelPopup = () => { document.getElementById("send-plan-popup-button").click() }

    getAeromeghPlans = () => {
        API.getAeromeghPlans().then(res => {
            if (res.plans.length > 0) {
                this.setState((state) => ({
                    ...state,
                    plans: res.plans
                }))
            } else {
                return 0
            }
        }).catch(e => { console.log(e) })
    }

    getBillingDetails = () => {
        API.getBillingDetails()
            .then(res => {
                this.setState({ billingDetails: res })
            })
            .catch(err => {
                this.setState({ error: "Failed to load billing details" })
            });
    }


    getSelectedActiveTeam = async () => {
        try {
            let selectedActiveTeam = await getActiveTeam();
            this.setState({ activeTeam: selectedActiveTeam })
        } catch (err) { console.log("error : ", err) }
    }

    getCountries = () => {
        API.getCountries().then((data) => {
            let country = this.state.user.country && this.state.user.country != '-' ? this.state.user.country : '-'
            this.setState((state) => ({
                ...state,
                countryLoader: false,
                countries: data.countries,
                user: {
                    ...state.user,
                    country: country,
                }
            }))
            if (country != '-') {
                country = this.state.countries?.find(data => data.country == country)
                this.getStates(country?.iso_code)
            }
        }, (e) => {
            console.log(e);
        })
    }
    getStates = (iso_code, context = 'address') => {
        if (iso_code) {
            API.getStates(iso_code).then((data) => {
                if (context === 'billing') {
                    this.setState({
                        billingStateLoader: false,
                        billingStates: data.states || [],
                    });
                } else {
                    let userstate = this.state.countryChange && data.states && data.states.length > 0 ? '-' : this.state.user.state;
                    if (!this.state.countryChange && this.state.user.state) {
                        userstate = this.state.user.state;
                    }
                    this.setState({
                        stateLoader: false,
                        states: data.states,
                        user: {
                            ...this.state.user,
                            state: userstate,
                            countryChange: false,
                        },
                    });
                }
            }).catch((e) => {
                console.error('Error loading states:', e);
                this.setState({
                    [context === 'billing' ? 'billingStateLoader' : 'stateLoader']: false,
                    error: 'Failed to load states',
                });
            });
        }
    };

    componentDidMount() { API.getViewerMinutesStats().then(r => { this.setState({ viewMinutesStats: r }) }).catch(e => { alert(e) }) }

    canUserUpgrade = (sub) => { return this.state.subscriptionTitleMap[sub] == "AeroMegh Free" ? true : false }

    componentWillMount() {
        document.title = "My Profile - AeroMegh";
        if (this.props) {
            let { user, type } = this.props;
            if (!user.sub) {
                user.sub = {
                    "plan": "aeromegh_plan_free"
                }
            }
            if (user.avatar_url && user.avatar_url.length > 0) {
                this.setState((state) => ({
                    ...state,
                    avatarURL: `${user.avatar_url}?${user.sas_token}&t${new Date().getTime()}`
                }))

            } else {
                let avatarURL = `/images/${user.first_name[0].toLowerCase()}.PNG`
                this.setState((state) => ({
                    ...state,
                    avatarURL: avatarURL
                }))
            }
            this.setState((state) => ({
                ...state,
                user,
                type,
            }), async () => {

                this.getAeromeghPlans();
                this.getAllSubscriptions();
                this.getSelectedActiveTeam();
                this.getCountries();
                this.getBillingDetails();
            })
        } else {
            API.getUserType().then(([blah, type, user]) => {
                if (!user.sub) {
                    user.sub = {
                        "plan": "aeromegh_plan_free"
                    }
                }

                this.setState((state) => ({
                    ...state,
                    user,
                    type
                }), async () => {
                    this.getAeromeghPlans();
                    this.getAllSubscriptions();
                    this.getSelectedActiveTeam();
                    this.getCountries();
                    this.getBillingDetails();
                })
            }, (e) => {
                window.location.replace("/login");
            })
        }
    }

    handleUserDetails = (e) => {
        let name = e.target.name;
        let value = e.target.value;

        const check = (checkData) => {
            let expression = checkData == 'eml'
                ? /^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/
                : /^\d{10}$/;
            let len = checkData == 'eml' ? 30 : 10;

            if (value.length <= len) {
                const updatedUser = { ...this.state.user, [name]: value || "" };

                // Validation flags
                let updatedWarnings = { ...this.state.personalDetailsWarning };

                if (expression.test(value)) {
                    if (checkData === 'eml') updatedWarnings.invalidEmail = false;
                    else updatedWarnings.invalidPhone = false;
                } else {
                    if (checkData === 'eml') updatedWarnings.invalidEmail = true;
                    else updatedWarnings.invalidPhone = true;
                }

                // Check samePhone after setting value
                if (name === 'phone' && this.state.billingDetails?.mob_number === value) {
                    updatedWarnings.samePhone = true;
                } else if (name === 'phone') {
                    updatedWarnings.samePhone = false;
                }

                this.setState({
                    user: updatedUser,
                    personalDetailsWarning: updatedWarnings
                });
            }
        };

        if (name === 'phone') {
            check(); // will handle both validation + samePhone
        } else if (name === 'country') {
            this.setState(
                {
                    user: { ...this.state.user, [name]: value || "", state: '-' },
                    stateLoader: true
                },
                () => {
                    this.state.countries.forEach(country => {
                        if (country.country === value) this.getStates(country.iso_code);
                    });
                }
            );
        } else if (name === 'username') {
            check('eml'); // email validation
        } else if (value.length <= 30) {
            this.setState({ user: { ...this.state.user, [name]: value || "" } });
        }
    };



    getBase64 = file => {
        return new Promise(resolve => {
            let fileSize = file.size / 1000
            if (fileSize > (this.state.FILE_SIZE_LIMIT * 1000)) {
                this.setState((state) => ({
                    ...state,
                    selectedFile: file,
                    sizeCheckPopup: true
                }))
            }
            else {
                let baseURL = "";
                // Make new FileReader
                let reader = new FileReader();
                // Convert the file to base64 text
                reader.readAsDataURL(file);
                // on reader load somthing...
                reader.onload = () => {
                    // Make a fileInfo Object
                    baseURL = reader.result;
                    resolve(baseURL);
                };
            }
        });
    };

    checkPersonalDetails = () => {
        return (this.state.personalDetailsWarning.invalidPhone
            || this.state.user.first_name == ""
            || this.state.user.last_name == ""
            || this.state.user.first_name == ""
            || this.state.user.last_name == ""
        );
    }

    checkAddressDetails = () => {
        return (this.state.user.address == ""
            || this.state.user.country == ""
            || this.state.user.state == ""
            || this.state.user.address == "-"
            || this.state.user.country == "-"
            || this.state.user.state == "-"
        );
    }

    handleBillingDetails = (e) => {
        const { name, value } = e.target;
        if (name === 'full_name') {
            const sanitizedValue = value
                .replace(/[^A-Za-z ]/g, '')
                .replace(/\s+/g, ' ')

            const isValid = /^[A-Za-z]+( [A-Za-z]+)*$/.test(sanitizedValue) && sanitizedValue.length >= 3;

            this.setState((prevState) => ({
                billingDetails: {
                    ...prevState.billingDetails,
                    [name]: sanitizedValue,
                },
                isBillingNameInvalid: !isValid,
            }));
        } else if (name === 'country') {
            this.setState(
                {
                    billingDetails: { ...this.state.billingDetails, [name]: value || '', state: '-' },
                    billingStateLoader: true,
                },
                () => {
                    if (value !== '-') {
                        this.state.countries.forEach((country) => {
                            if (country.country === value) {
                                this.getStates(country.iso_code, 'billing');
                            }
                        });
                    } else {
                        this.setState({ billingStates: [], billingStateLoader: false });
                    }
                }
            );
        } else {
            this.setState({
                billingDetails: { ...this.state.billingDetails, [name]: value || '' },
            });
        }
    };

    checkBillingDetails = () => {
        const { billingDetails } = this.state;
        return (
            billingDetails.full_name === '' ||
            billingDetails.isBillingNameInvalid ||
            billingDetails.company_name === '' ||
            billingDetails.billing_address === '' ||
            billingDetails.gst_number === '' ||
            billingDetails.mob_number === '' ||
            billingDetails.billing_email === '' ||
            billingDetails.pin_code === '' ||
            billingDetails.country === '-' ||
            billingDetails.state === '-'
        );
    };

    isBillingDetailsSameAsUser = () => {
        const { billingDetails } = this.state;
        const { user } = this.props;
        return (
            billingDetails.mob_number === user.phone ||
            billingDetails.billing_email?.trim().toLowerCase() === user.username?.trim().toLowerCase()
        );
    };

    submitBillingInfo = () => {
        const { billingDetails } = this.state;
        API.updateBillingDetails(billingDetails)
            .then((res) => {
                this.setState({
                    billingDetails: res,
                    isBillingDetailsEditable: false,
                });
            })
            .catch((err) => {
                console.error('Failed to update billing info:', err);
                this.setState({ error: 'Failed to update billing info' });
            });
    };



    render() {
        const { show, close, missingFields, onSuccess } = this.props;
        let { user, billingDetails, type } = this.state;

        const customStyles = {
            content: {
                top: '50%',
                left: '50%',
                right: 'auto',
                bottom: 'auto',
                marginRight: '-50%',
                transform: 'translate(-50%, -50%)',
                width: '700px',
                padding: '20px',
                borderRadius: '8px',
            },
            overlay: {
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
            },
        };

        if (!show) return null;

        return (
            <Modal
                isOpen={show}
                onRequestClose={close}
                style={customStyles}
                shouldCloseOnOverlayClick={false}
                contentLabel="Update Billing Contact Details"
            >
                <h2 style={{ marginBottom: '20px', fontSize: '20px', textAlign: 'center' }}>
                    Update Billing Contact Details
                </h2>

                <form style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
                    <p>Primary Details</p>
                    <div style={{ width: "100%", padding: '0 10px 10px 10px', }}>
                        <div style={{ display: "flex", marginBottom: "10px" }}>
                            <div style={{ width: "50%" }}>
                                <div style={{ color: '#1f384c80', fontSize: '13px' }}>First name</div>
                                <div><input type='text'
                                    required
                                    autoFocus
                                    value={user?.first_name || ""}
                                    name='first_name'
                                    placeholder='First name'
                                    className='settings-input'
                                    onChange={(e) => {
                                        let check = /^[A-Za-z]*$/;
                                        if (check.test(e.target.value)) this.handleUserDetails(e)
                                    }}
                                /></div>
                            </div>
                            <div style={{ width: "50%" }}>
                                <div style={{ color: '#1f384c80', fontSize: '13px' }}>Last name</div>
                                <div><input type='text'
                                    required
                                    value={user?.last_name || ""}
                                    name='last_name'
                                    placeholder='Last name'
                                    className='settings-input'
                                    onChange={(e) => {
                                        let check = /^[A-Za-z]*$/;
                                        if (check.test(e.target.value)) this.handleUserDetails(e)
                                    }}
                                /></div>
                            </div>
                        </div>
                        <div style={{ display: "flex", marginBottom: "10px" }}>
                            <div style={{ width: "50%" }}>
                                <div style={{ color: '#1f384c80', fontSize: '13px' }}>Phone Number</div>
                                <div><input type='text'
                                    required
                                    value={user?.phone || ""}
                                    name='phone'
                                    placeholder='Phone'
                                    className='settings-input'

                                    onChange={(e) => {
                                        let check = /^[0-9]*$/;
                                        if (check.test(e.target.value) && e.target.value.length <= 10) this.handleUserDetails(e)
                                    }}
                                /></div>
                            </div>
                            <div style={{ width: "50%" }}>
                                <div style={{ color: '#1f384c80', fontSize: '13px' }}>Email</div>
                                <div><span style={{ fontSize: '13px', marginRight: '10px' }}>{user.username || '-'}</span>
                                    {<img src={verifiedIcon} alt='verified icon' style={{ height: '13px' }} />}
                                </div>
                            </div>
                        </div>
                        <div style={{ display: "flex", }}>
                            {this.state.personalDetailsWarning.invalidEmail || this.state.personalDetailsWarning.invalidPhone || this.state.personalDetailsWarning.samePhone ? <div style={{ width: "50%" }}>
                                <div style={{ color: 'red', fontSize: '10px' }}>
                                    {this.state.personalDetailsWarning.invalidEmail && this.state.personalDetailsWarning.invalidPhone
                                        ? 'Please ensure that the email address and phone number you provided.'
                                        : this.state.personalDetailsWarning.invalidEmail
                                            ? 'please memtion valid email address.'
                                            : this.state.personalDetailsWarning.invalidPhone
                                                ? 'Invalid phone number.'
                                                : this.state.personalDetailsWarning.samePhone
                                                    ? 'Phone number should be different from secondary number.' : ''
                                    }
                                </div>
                            </div> : <></>}
                        </div>
                    </div>
                    <div style={{ width: "100%", padding: '0 10px 10px 10px', }}>
                        <div style={{ display: "flex", marginBottom: "10px" }}>
                            <div style={{ width: "50%" }}>
                                <div style={{ color: '#1f384c80', fontSize: 'small' }}>Country</div>
                                <div>
                                    <select name="country" style={{ width: "200px", maxWidth: "200px", }} className="add-user-form-text" value={this.state.user.country} required
                                        onChange={(e) => { this.handleUserDetails(e) }}
                                    >
                                        <option value={'-'} disabled>
                                            {this.state.countryLoader == true ?
                                                `Loading Countries` : `Select Country`}
                                        </option>
                                        {this.state.countries?.length > 0 ?
                                            this.state.countries.map((country) => {
                                                return <option key={country.iso_code} value={country.country}>
                                                    {country.country}
                                                </option>
                                            }) :
                                            <option>no countries found</option>
                                        }
                                    </select>
                                </div>
                            </div>
                            <div style={{ width: "50%" }}>
                                <div style={{ color: '#1f384c80', fontSize: 'small' }}>State</div>
                                <div>
                                    {!this.state.stateLoader ? <select name="state" style={{ width: "200px", maxWidth: "200px", opacity: this.state.stateLoader ? "0.5" : "1" }} className="add-user-form-text" value={this.state.user.state} required onChange={(e) => { this.handleUserDetails(e) }}>
                                        <option value={'-'} disabled> {`Select State`}  </option>
                                        {this.state.states?.map((state, key) => {
                                            return <option value={state.name}>{state.name}</option>
                                        })}
                                    </select> : <div className="add-user-form-text" style={{ opacity: "0.5", display: "flex", justifyContent: "left", alignItems: "center", width: "auto" }}>Loading...</div>}
                                </div>
                            </div>
                        </div>
                        <div style={{ display: "flex", marginBottom: "10px" }}>
                            <div style={{ width: "50%" }}>
                                <div style={{ color: '#1f384c80', fontSize: 'small' }}>Address</div>
                                <div><input type='text'
                                    required
                                    value={user?.address || ""}
                                    name='address'
                                    placeholder='address'
                                    className='settings-input'
                                    onChange={(e) => this.handleUserDetails(e)}
                                /></div>
                            </div>
                            <div style={{ width: "50%" }}>
                                <div style={{ color: '#1f384c80', fontSize: 'small' }}>Pin Code</div>
                                <div><input type='text'
                                    required
                                    value={user?.pin_code || ""}
                                    name='pin_code'
                                    placeholder='Pincode'
                                    className='settings-input'
                                    onChange={(e) => this.handleUserDetails(e)}
                                /></div>
                            </div>
                        </div>
                    </div>
                    <p>Secondary Details</p>
                    <div style={{ width: "100%", padding: '0 10px 10px 10px', }}>
                        <div style={{ display: "flex", marginBottom: "10px" }}>
                            <div style={{ width: "50%" }}>
                                <div style={{ color: '#1f384c80', fontSize: '13px' }}>Full name</div>
                                <div><input type='text'
                                    required
                                    value={billingDetails?.full_name || ""}
                                    name='full_name'
                                    placeholder='Full name'
                                    className='settings-input'
                                    maxLength={50}
                                    onChange={(e) => {
                                        this.handleBillingDetails(e)
                                    }}
                                /></div>
                            </div>
                            <div style={{ width: "50%" }}>
                                <div style={{ color: '#1f384c80', fontSize: '13px' }}>Company Name</div>
                                <div><input type='text'
                                    required
                                    value={billingDetails?.company_name || ""}
                                    name='company_name'
                                    placeholder='Company name'
                                    className='settings-input'
                                    maxLength={50}
                                    onChange={(e) => {
                                        this.handleBillingDetails(e)
                                    }}
                                /></div>
                            </div>
                        </div>
                        <div style={{ display: "flex", marginBottom: "10px" }}>
                            <div style={{ width: "50%" }}>
                                <div style={{ color: '#1f384c80', fontSize: '13px' }}>Address</div>
                                <div><input type='text'
                                    required
                                    value={billingDetails?.billing_address || ""}
                                    name='billing_address'
                                    placeholder='Address'
                                    className='settings-input'

                                    onChange={(e) => {
                                        this.handleBillingDetails(e)
                                    }}
                                /></div>
                            </div>
                            <div style={{ width: "50%" }}>
                                <div style={{ color: '#1f384c80', fontSize: '13px' }}>Mobile Number</div>
                                <div>
                                    <input
                                        type='number'
                                        required
                                        value={billingDetails?.mob_number || ""}
                                        name='mob_number'
                                        placeholder='Mobile Number'
                                        className='settings-input'
                                        onChange={(e) => {
                                            let value = e.target.value;

                                            // Remove non-digit characters (just in case)
                                            value = value.replace(/\D/g, '');

                                            // Enforce 10-digit limit
                                            if (value.length > 10) {
                                                value = value.slice(0, 10);
                                            }

                                            const isValid = /^[0-9]{10}$/.test(value);
                                            const isSame = value === this.props.user.phone;

                                            this.setState(prevState => ({
                                                billingDetails: {
                                                    ...prevState.billingDetails,
                                                    mob_number: value
                                                },
                                                isBillingPhoneInvalid: !isValid,
                                                isBillingPhoneSameAsUser: isSame
                                            }));
                                        }}
                                    />


                                    {this.state.isBillingPhoneInvalid && (
                                        <div style={{ color: 'red', fontSize: '12px' }}>
                                            Invalid phone number. Must be 10 digits.
                                        </div>
                                    )}
                                    {this.state.isBillingPhoneSameAsUser && !this.state.isBillingPhoneInvalid && (
                                        <div style={{ color: 'red', fontSize: '12px' }}>
                                            Phone number cannot be same as your personal phone number.
                                        </div>
                                    )}
                                </div>
                            </div>


                        </div>
                        <div style={{ display: "flex", marginBottom: "10px" }}>
                            <div style={{ width: "50%" }}>
                                <div style={{ color: '#1f384c80', fontSize: '13px' }}>Email</div>
                                <div>
                                    <input
                                        type='email'
                                        required
                                        value={billingDetails?.billing_email || ""}
                                        name='billing_email'
                                        placeholder='Email'
                                        className='settings-input'
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

                                            const isValid = emailRegex.test(value.trim());
                                            const isSame = value.trim().toLowerCase() === this.props.user.username?.trim().toLowerCase();

                                            this.setState(prevState => ({
                                                billingDetails: {
                                                    ...prevState.billingDetails,
                                                    billing_email: value
                                                },
                                                isBillingEmailInvalid: !isValid,
                                                isBillingEmailSameAsUser: isSame
                                            }));
                                        }}
                                    />
                                    {this.state.isBillingEmailInvalid && (
                                        <div style={{ color: 'red', fontSize: '12px' }}>
                                            Invalid email address
                                        </div>
                                    )}
                                    {this.state.isBillingEmailSameAsUser && (
                                        <div style={{ color: 'red', fontSize: '12px' }}>
                                            Billing email must not be same as account email
                                        </div>
                                    )}

                                </div>

                            </div>
                            <div style={{ width: "50%" }}>
                                <div style={{ color: '#1f384c80', fontSize: '13px' }}>Pin Code</div>
                                <div>
                                    <input type='email' required value={billingDetails?.pin_code || ""} name='pin_code' placeholder='Pincode' className='settings-input'
                                        onChange={(e) => { this.handleBillingDetails(e) }} />
                                </div>
                            </div>
                        </div>
                        <div style={{ display: 'flex', marginBottom: '10px' }}>
                            <div style={{ width: '50%' }}>
                                <div style={{ color: '#1f384c80', fontSize: 'small' }}>Country</div>
                                <div>
                                    <select name="country" style={{ width: "200px", maxWidth: "200px", }} className="add-user-form-text" value={this.state.billingDetails.country} required onChange={this.handleBillingDetails} >
                                        <option value="-" disabled>
                                            {this.state.countryLoader ? 'Loading Countries' : 'Select Country'}
                                        </option>
                                        {this.state.countries?.length > 0 ? (
                                            this.state.countries.map((country) => (
                                                <option key={country.iso_code} value={country.country}>
                                                    {country.country}
                                                </option>
                                            ))
                                        ) : (
                                            <option>No countries found</option>
                                        )}
                                    </select>
                                </div>
                            </div>
                            <div style={{ width: "50%" }}>
                                <div style={{ color: '#1f384c80', fontSize: 'small' }}>State</div>
                                <div>
                                    {!this.state.billingStateLoader ? <select name="state" style={{ width: "200px", maxWidth: "200px", opacity: this.state.billingStateLoader ? "0.5" : "1" }} className="add-user-form-text" value={this.state.billingDetails.state} required onChange={(e) => { this.handleBillingDetails(e) }}>
                                        <option value={'-'} disabled>Select State</option>
                                        {this.state.billingStates?.map((state, key) => {
                                            return <option key={state.name} value={state.name}>{state.name}</option>
                                        })}
                                    </select> : <div className="add-user-form-text" style={{ opacity: "0.5", display: "flex", justifyContent: "left", alignItems: "center", width: "auto" }}>Loading...</div>}
                                </div>
                            </div>
                        </div>
                        <div style={{ width: "100%", padding: '0 10px 10px 10px', }}>
                            <div style={{ display: "flex", marginBottom: "10px" }}>
                                <div style={{ width: "50%" }}>
                                    <div style={{ color: '#1f384c80', fontSize: '13px' }}>GST Number</div>
                                    <div><input type='text'
                                        required
                                        value={billingDetails?.gst_number || ""}
                                        name='gst_number'
                                        placeholder='GST Number'
                                        className='settings-input'
                                        onChange={(e) => {
                                            this.handleBillingDetails(e)
                                        }}
                                    /></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>


                <div style={{ display: 'flex', justifyContent: 'end', gap: '10px' }}>
                    <ButtonWithIcon isBtnActive text={"Update Now"} disabled={this.isUpdateDisabled()} css={{
                        opacity: this.checkBillingDetails() || this.isBillingDetailsSameAsUser() || this.state.isBillingPhoneInvalid || this.state.isBillingNameInvalid ? "0.5" : "1",
                        cursor: this.checkBillingDetails() || this.isBillingDetailsSameAsUser() || this.state.isBillingPhoneInvalid || this.state.isBillingNameInvalid ? "not-allowed" : "pointer"
                    }}
                        onClick={() => {
                            if (!this.checkPersonalDetails() && !this.isBillingDetailsSameAsUser() && !this.checkAddressDetails() && !this.checkBillingDetails()) {
                                this.submitEditUser()
                            };
                            if (!this.checkBillingDetails() && !this.isBillingDetailsSameAsUser() && !this.state.isBillingPhoneInvalid && !this.state.isBillingNameInvalid) {
                                this.submitBillingInfo();
                            }
                            close();
                        }}
                        linkData={{ pathname: "/profile-settings" }}
                    />
                </div>

            </Modal>
        );
    }
}
